import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function ReportEmptyIcon({ height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon fill="none" height={height ?? 40} viewBoxDimensions="0 0 40 40" width={width ?? 40}>
      <path
        d="M35 36.668H3.333"
        stroke="#9CA7AB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        clipRule="evenodd"
        d="M29.444 16.668h4.445c.613 0 1.11 1.12 1.11 2.5v17.5h-6.666v-17.5c0-1.38.498-2.5 1.111-2.5zM16.944 10h4.445c.613 0 1.11.853 1.11 1.905v24.762h-6.666V11.905c0-1.052.498-1.905 1.111-1.905zM4.444 21.668H8.89c.613 0 1.11.373 1.11.833v14.167H3.334V22.501c0-.46.497-.833 1.111-.833z"
        stroke="#9CA7AB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
